'use strict';

import FormInput from "./FormInput";

export default function FormAgreement({
    showCheckboxMedia = true,
    agreeConditionsValue = false,
    agreeMediaValue = false,
    onAgreeConditionsChange = undefined,
    onAgreeMediaChange = undefined,
    textConditions = tMsg('Я принимаю условия пользовательского соглашения и даю согласие на обработку персональных данных'),
    textMedia = tMsg("Даю согласие на получение полезного контента в информационно-рекламных рассылках"),
    tag = undefined,
}) {

    const isTravel = isVersionEN;
    const showRu = !isTravel && lang === 'ru';
    
    const conditionsLink = isTravel
        ? 'terms-and-conditions-travel'
        : showRu ? 'agreement' : 'privacy-policy'

    const policyLink = isTravel
        ? 'policy-travel'
        : showRu ? 'personal-data-policy' : 'privacy-policy'
    
    const conditionsModal = isTravel 
        ? 'termsAndConditionsModal' 
        : showRu ? 'agreementModal' : 'privacyPolicyModal'
    
    const handleConditionsClick = (value) => {
        onAgreeConditionsChange && onAgreeConditionsChange(value)
    }

    const handleMediaClick = (value) => {
        onAgreeMediaChange && onAgreeMediaChange(value)
    }

    return <React.Fragment>
        
        <FormInput
            type={'checkbox'}
            label={{
                tag: tag,
                text: textConditions,
                replace: [
                    {
                        text: tMsg('условия пользовательского соглашения'),
                        href: `${langPrefix}/` + conditionsLink,
                        target: '_blank',
                        modal: conditionsModal,
                        checkOnSuccess: true,
                    },
                    {
                        text: showRu ? tMsg('обработку персональных данных') : tMsg('персональных данных'),
                        href: `${langPrefix}/` + policyLink,
                        target: '_blank',
                        modal: showRu ? 'personalDataPolicyModal' : 'privacyPolicyModal',
                        checkOnSuccess: true,
                    }
                ]
            }}
            value={agreeConditionsValue}
            onChange={value => handleConditionsClick(value)}
        />
        
        {showCheckboxMedia && <FormInput
            type={'checkbox'}
            label={{
                text: textMedia,
            }}
            value={agreeMediaValue}
            onChange={value => handleMediaClick(value)}
        />}
        
    </React.Fragment>
}
